/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PolicyPageIdRouteImport } from './routes/policy/$pageId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyPageIdRoute = PolicyPageIdRouteImport.update({
  id: '/policy/$pageId',
  path: '/policy/$pageId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/policy/$pageId': typeof PolicyPageIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/policy/$pageId': typeof PolicyPageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/policy/$pageId': typeof PolicyPageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/policy/$pageId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/policy/$pageId'
  id: '__root__' | '/' | '/policy/$pageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PolicyPageIdRoute: typeof PolicyPageIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy/$pageId': {
      id: '/policy/$pageId'
      path: '/policy/$pageId'
      fullPath: '/policy/$pageId'
      preLoaderRoute: typeof PolicyPageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PolicyPageIdRoute: PolicyPageIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
